export class UnitFullName {
  constructor(public first: string = null, public last: string = null) {}
}
